

export default {
    head() {
        return {
            title: `${this.infoGenerales?.attributes?.icfaDetailsTitle}`,
            meta: this.infoGenerales?.attributes?.icfaDetailsMeta != null && this.infoGenerales?.attributes?.icfaDetailsMeta != undefined ?
                JSON.parse(this.infoGenerales?.attributes?.icfaDetailsMeta?.replace('\n', '')) : null
        };
        // return {
            // title: `ICFA - Homepage`,
            // meta: [
            //     {
            //         hid: 'og-title',
            //         property: 'og:title',
            //         content: 'ICFA - Formations par alternance - Bac+2 à Bac+3',
            //     },
            //     {
            //         hid: 'og-description',
            //         property: 'og:description',
            //         content: `Rejoignez l'ICFA pour des formations en alternance Bac+2 à Bac+3. Dans les Campus : St François, Lycée Nevers, La Merci Littoral, et St Joseph Pierre Rouge.`,
            //     }
            // ]
        // };
    },



    methods: {

        styles(instance) {
            let r, g, b;
            r = instance?.attributes?.couleurCampusCardRGB?.substring(0, 3);
            g = instance?.attributes?.couleurCampusCardRGB?.substring(3, 6);
            b = instance?.attributes?.couleurCampusCardRGB?.substring(6, 9);

            return {
                '--text-color': '#aaaaaa',
                '--text-color1r': Number(r),
                '--text-color1g': Number(g),
                '--text-color1b': Number(b),
            };
        },
        scrollToCampusSmallButton() {
            const element = document.getElementById("campus");
            element.scrollIntoView({ behavior: 'smooth' });
        },
    },




    async asyncData({ params, $http, store }) {
        let instances = JSON.parse(JSON.stringify(store.state.instances))
        let infoGenerales = JSON.parse(JSON.stringify(store.state.infoGenerales));

        if (instances.length == 0) {
            let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances?populate=homePageCardImage`);
            instances = instances.data;
            instances.sort((a, b) => a.attributes.ordreHomePage - b.attributes.ordreHomePage)
            store.commit('setInstances', JSON.parse(JSON.stringify(instances)))

        }

        // let instances = store.state.instances;
        instances.map(instance => {
            instance.visibility = false;
            instance.diplomas = [];
        })

        const strapiBaseUri = process.env.strapiBaseUri

        let allDiplomas = JSON.parse(JSON.stringify(store.state.diplomas));

        let collone1Diplomas = allDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_1';
        })
        collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })
        let collone2Diplomas = allDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_2';
        })
        collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })
        let collone3Diplomas = allDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_3';
        })
        collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })

        allDiplomas = collone1Diplomas.concat(collone2Diplomas).concat(collone3Diplomas);

        if (allDiplomas.length == 0) {
            for (const instance of instances) {
                const campusUrl = `${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-diplomas?populate=domaine,niveauDiplome`;
                const campusDiplomaInfos = await $http.$get(campusUrl);
                campusDiplomaInfos.data.map(diplome => {
                    diplome.campus = instance.attributes.prefix;
                })
                allDiplomas = allDiplomas.concat(campusDiplomaInfos.data)
            }
            let collone1Diplomas = allDiplomas.filter((diploma) => {
                return diploma?.attributes.collone === 'Collone_1';
            })
            collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
                return d1?.attributes.ordre - d2?.attributes.ordre
            })
            let collone2Diplomas = allDiplomas.filter((diploma) => {
                return diploma?.attributes.collone === 'Collone_2';
            })
            collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
                return d1?.attributes.ordre - d2?.attributes.ordre
            })
            let collone3Diplomas = allDiplomas.filter((diploma) => {
                return diploma?.attributes.collone === 'Collone_3';
            })
            collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
                return d1?.attributes.ordre - d2?.attributes.ordre
            })

            allDiplomas = collone1Diplomas.concat(collone2Diplomas).concat(collone3Diplomas);
            store.commit('setDiplomas', JSON.parse(JSON.stringify(allDiplomas)))
        }

        allDiplomas.map(diplome => {
            diplome.visibility = false;
            diplome.selected = false;
            instances.filter(instance => instance.attributes.prefix == diplome.campus)[0].diplomas.push(diplome)
        })

        let icfaDetails = await $http.$get(`${process.env.strapiBaseUri}/api/icfa-details-page?populate=imageEtapes`);
        icfaDetails = icfaDetails.data;

        let imageEtapesUrl = process.env.strapiBaseUri + icfaDetails?.attributes?.imageEtapes?.data?.attributes?.url;

        return {
            instances, strapiBaseUri, allDiplomas, infoGenerales, icfaDetails, imageEtapesUrl
        }
    },

}
